import React from 'react'
import DashboardTable from '../dashboardtable/dashboardtable';
import data from './data.json'
import search from '../../../../assets/images/search.png'
import add from '../../../../assets/images/add.png'
import Calender from "../../calender/calender";
import {Modal,Button} from "react-bootstrap";


function PermitBook() {

    const [modalShow, setModalShow] = React.useState(false);


    return (
        <>
            <div className='driver-head'>
                <h3 className='dashboard-head-title'>Brokers</h3>
                <div>
                    <div className='input-header-admin'>
                        <input
                            type="text"
                            placeholder='Search' />
                        <img src={search} alt="" />
                    </div>
                    <div className='nav-buttons'>
                        <button onClick={() => setModalShow(true)} style={{ background: '#FF7B00', marginRight: '15px' }}>Calender</button>
                    </div>
                    <div className='nav-buttons'>
                        <button style={{ background: '#FF7B00', marginRight: '15px' }}><img src={add} alt="" />  Add Driver</button>
                    </div>
                </div>
            </div>
            <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
            <div className='dashboard-table-wrapper_'>
                <DashboardTable size={10} columns={columns} rows={data.data} height={"510px"} />
            </div>
        </>
    )
}

const columns = [
    { field: 'driverLic', headerName: 'Drivers License', minWidth: 190 },
    { field: 'medicalPermit', headerName: 'Medical Permit', minWidth: 190 },
    { field: 'da', headerName: 'Drug and Alcohol Cons. Enrollment, Kit, and Results', minWidth: 250 },
    { field: 'ar', headerName: 'Accident Reporting Kit', minWidth: 250 }
];


function MyVerticallyCenteredModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Calender
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Calender/>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PermitBook